module.exports = __webpack_public_path__ + "static/gradientOne-5150b5f69ad62f60f729981e9925921b.png";